// Mirrors Websites::StyleCompiler so a style change can be applied to the
// canvas without a round trip. The token list ships from the server in the
// builder's schema payload, so the two cannot drift.

export const breakpointSuffix = (breakpoint) => (breakpoint === "base" ? "" : `-${breakpoint}`)

export const compileValue = (value, tokens) => {
  if (value === null || value === undefined || value === "") return null
  const raw = String(value)
  return tokens.includes(raw) ? `var(--${raw})` : raw
}

export const applyStyle = (element, key, value, breakpoint, tokens) => {
  if (!element) return
  const property = `--${key}${breakpointSuffix(breakpoint)}`
  const compiled = compileValue(value, tokens)
  if (compiled === null) element.style.removeProperty(property)
  else element.style.setProperty(property, compiled)
}
